export default __webpack_public_path__ + "static/media/Montserrat-Regular.1b2f3aba.eot";